// extracted by mini-css-extract-plugin
export var inputContainer = "_o6-0";